import Head from 'next/head'
import { useRouter } from 'next/router'
import {
  DEFAULT_THUMBNAIL,
  OG_IMAGE_HEIGHT,
  SITE_NAME,
  TWITTER_CARD,
  TWITTER_HANDLE,
} from 'libs/constants'
import { getUrlWithoutQueryParams } from 'libs/utils'

interface MetaProps {
  title: string
  description: string
  keywords: string
  socialDescription: string
}

export const Meta = ({
  title,
  description,
  keywords,
  socialDescription,
}: MetaProps) => {
  const { asPath } = useRouter()

  return (
    <Head>
      <meta content={getUrlWithoutQueryParams(asPath)} property='og:url' />
      <meta content={SITE_NAME} property='og:site_name' />
      <meta content={description} name='description' />
      <meta content={keywords} name='keywords' />
      <meta content={title} property='og:title' />
      <meta content={socialDescription} property='og:description' />
      <meta content={DEFAULT_THUMBNAIL} property='og:image' />
      <meta content={OG_IMAGE_HEIGHT} property='og:image:height' />
      <meta content={TWITTER_CARD} name='twitter:card' />
      <meta content={TWITTER_HANDLE} name='twitter:site' />
      <meta content={title} property='twitter:title' />
      <meta content={socialDescription} name='twitter:description' />
      <meta content={DEFAULT_THUMBNAIL} name='twitter:image' />
    </Head>
  )
}
